// extracted by mini-css-extract-plugin
export default {"container":"AppLayout_container__EfNvh"};